module.exports = __webpack_public_path__ + "img/valor.9bcf0f22.png";